export { getBrandInfo, receiveBrandInfo } from './actions';
export { default as reducer } from './reducer';
